import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../pages/certifications/components/data-table";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { EntityItem } from "./types";

dayjs.extend(utc);
dayjs.extend(timezone);

export function getEntityColumns(
  onEdit: (row: EntityItem) => void,
  onDelete: (row: EntityItem) => void
): ColumnDef<EntityItem>[] {
  return [
    {
      accessorKey: "name",
      header: () => <div className="p-0">Name</div>,
      cell: ({ row }) => <div>{row.original.name}</div>,
    },
    {
      accessorKey: "createdAt",
      header: () => <div className="p-0">Date Created</div>,
      cell: ({ row }) => (
        <span>{dayjs(row.original.createdAt).utc().format("MMM DD, YYYY")}</span>
      ),
    },
    {
      id: "actions",
      header: () => <div className="w-full flex justify-end">Session</div>,
      cell: ({ row }) => (
        <div className="w-full flex justify-end gap-2">
          <button
            onClick={() => onEdit(row.original)}
            className="text-sm text-center text-text2 hover:text-primary3"
          >
            Edit
          </button>
          <button
            onClick={() => onDelete(row.original)}
            className="text-sm text-center text-red-500 hover:text-primary3"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];
}

export function EntityTable({
  data,
  isLoading,
  onEdit,
  onDelete,
}: {
  data: EntityItem[];
  isLoading: boolean;
  onEdit: (row: EntityItem) => void;
  onDelete: (row: EntityItem) => void;
}) {
  const columns = getEntityColumns(onEdit, onDelete);
  return (
    <div>
      <div className="flex flex-col gap-5 [&_.data-table-container]:!h-[calc(100dvh-300px)]">
        <DataTable columns={columns} data={data ?? []} isLoading={isLoading} />
      </div>
    </div>
  );
}
